import React from 'react';
import { Table } from 'antd';

const CustomTable = ({ ...props }) => {
  return <Table {...props} />;
};

export default CustomTable;
